<!-- tap on top starts-->
<div
    class="tap-top"
    (click)="tapToTop()"
    [ngStyle]="{ display: show ? 'block' : 'none' }"
>
    <i [attr.data-feather]="'chevrons-up'"></i>
</div>
<!-- tap on tap ends-->
